import styled from 'styled-components';

export const SecondarySystemsDropdownContainer = styled.div`
  width: 100%;
`;
